import { usePermissions } from '@/hooks/use-permission.ts';
import type { MetricKey } from '@/components/energy-management-chart.tsx';

const METRIC_ACTIONS = [
  'pv_production',
  'consumed',
  'consumed_from_grid',
  'fed_to_grid',
  'battery_charge',
  'battery_discharge',
  'battery_state_of_charge',
  'ropex_dam_price',
] as const satisfies readonly MetricKey[];

export const useMetricPermissions = (): MetricKey[] => {
  const results = usePermissions(
    METRIC_ACTIONS.map(
      (m) =>
        ['energy-management-chart', `view-metric.${m}`] as [
          'energy-management-chart',
          `view-metric.${typeof m}`,
        ]
    )
  );

  return METRIC_ACTIONS.filter((_, i) => !results[i]);
};
